import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center py-12 px-4 text-center" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "text-lg font-medium text-gray-900 mb-2" }
const _hoisted_5 = { class: "text-sm text-gray-500 max-w-md mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.icon === 'document')
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            class: _normalizeClass(["h-16 w-16", _ctx.iconClass]),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "1.5",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            }, null, -1)
          ]), 2))
        : (_ctx.icon === 'data')
          ? (_openBlock(), _createElementBlock("svg", {
              key: 1,
              class: _normalizeClass(["h-16 w-16", _ctx.iconClass]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "1.5",
                d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
              }, null, -1)
            ]), 2))
          : (_ctx.icon === 'folder')
            ? (_openBlock(), _createElementBlock("svg", {
                key: 2,
                class: _normalizeClass(["h-16 w-16", _ctx.iconClass]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5",
                  d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                }, null, -1)
              ]), 2))
            : (_ctx.icon === 'search')
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 3,
                  class: _normalizeClass(["h-16 w-16", _ctx.iconClass]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.5",
                    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  }, null, -1)
                ]), 2))
              : (_ctx.icon === 'custom')
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 4,
                    class: _normalizeClass(["h-16 w-16", _ctx.iconClass]),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "1.5",
                      d: _ctx.customIcon || ''
                    }, null, 8, _hoisted_3)
                  ], 2))
                : _createCommentVNode("", true)
    ]),
    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1),
    (_ctx.showAction)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(["px-4 py-2 rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", _ctx.actionClass || 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action')))
        }, _toDisplayString(_ctx.actionText), 3))
      : _createCommentVNode("", true)
  ]))
}